import React from 'react'
import { THEME } from 'components/theme'
import { LinkManager } from '../../utils'

interface IErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends React.Component<{ children: React.ReactNode }, IErrorBoundaryState> {
  static getDerivedStateFromError(): IErrorBoundaryState {
    return { hasError: true }
  }

  constructor(props: { children: React.ReactNode }) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
  }

  handleRedirectToLogin = () => {
    window.location.replace(LinkManager.getLoginLink())
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            fontFamily: 'Noto Sans, sans-serif',
            backgroundColor: THEME.brandBGLight
          }}
        >
          <div
            style={{
              textAlign: 'center',
              padding: '40px',
              backgroundColor: THEME.brandWhite,
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}
          >
            <h2 style={{ margin: '0 0 12px', color: '#333', fontSize: '20px' }}>
              Something went wrong
            </h2>
            <p style={{ margin: '0 0 24px', color: '#666', fontSize: '14px' }}>
              Your session may have expired. Please try reloading the page or log in again.
            </p>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <button
                onClick={this.handleReload}
                style={{
                  padding: '10px 24px',
                  fontSize: '14px',
                  backgroundColor: '#0B8043',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Reload Page
              </button>
              <button
                onClick={this.handleRedirectToLogin}
                style={{
                  padding: '10px 24px',
                  fontSize: '14px',
                  backgroundColor: THEME.brandWhite,
                  color: '#0B8043',
                  border: '1px solid #0B8043',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Go to Login
              </button>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
